import { SingleComment } from "../../Config/interface.config";
import { IoMdHeartEmpty, IoIosHeart } from "react-icons/io";
import userImg from "../../Assets/Images/user-profile.png";
import * as C from "./styled";
import { postAndCommentLinkHandler } from "../../Config/common.config";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { Capitalize } from "../../Utils";

interface Props {
  comment: SingleComment;
  postId: string;
}

const CommentSection = ({ comment, postId: post_id }: Props) => {
  const user = useSelector((state: RootState) => state.user);
  const [liked, setLiked] = useState<boolean>(false);
  const [likeCount, setLikeCount] = useState<number>(
    Array.isArray(comment?.likeCount) ? comment.likeCount.length : 0
  );

  const normalizeLike = (like: any) => {
    if (!like || typeof like === "string") return null;
    return like;
  };

  const onCommentLike = async () => {
    if (!post_id || typeof user.id !== "string" || !comment?._id) return;

    const nextLiked = !liked;
    setLiked(nextLiked);
    setLikeCount((current) =>
      nextLiked ? current + 1 : Math.max(current - 1, 0)
    );

    postAndCommentLinkHandler({ comment: comment._id, likedBy: user.id });
  };

  useEffect(() => {
    if (!comment || typeof user?.id !== "string" || !Array.isArray(comment.likeCount)) return;

    const likedByMe = comment.likeCount.find((like) => {
      const normalizedLike = normalizeLike(like);
      return Boolean(normalizedLike?.likedBy?._id === user.id);
    });

    setLiked(Boolean(likedByMe));
    setLikeCount(comment.likeCount.length);
  }, [comment, user?.id]);

  return (
    <>
      {
        <C.Comment key={`comment-${comment._id}`}>
          <div className="flex justify-between flex-row">
            <C.CommentFlex>
              <C.UserImg
                src={
                  comment.commentBy?.image?.fileURL
                    ? comment.commentBy?.image?.fileURL
                    : userImg
                }
                alt="user"
              />
              <div className="flex flex-col">
                <C.CommentText>
                  {comment.commentBy.username
                    ? Capitalize(comment.commentBy.username)
                    : Capitalize(comment.commentBy.fullname)}
                </C.CommentText>
                <C.CommentText>{comment.text}</C.CommentText>
              </div>
            </C.CommentFlex>
            <div onClick={onCommentLike}>
              {liked ? (
                <C.CommentLike>
                  <IoIosHeart
                    size={20}
                    fill="#ff0000"
                    className="cursor-pointer"
                  />
                  <span>{likeCount}</span>
                </C.CommentLike>
              ) : (
                <C.CommentLike>
                  <IoMdHeartEmpty
                    size={20}
                    fill="#fff"
                    className="cursor-pointer"
                  />
                  <span>{likeCount}</span>
                </C.CommentLike>
              )}
            </div>
          </div>
        </C.Comment>
      }
    </>
  );
};

export default CommentSection;
